import moment from "moment";
import { IShipmentsPerDay } from "../../../api/ShipmentsPerDay/ShipmentsPerDay.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IShipmentsPerDay[];
}

interface IrollCounterData {
  date: string,
  Shipments: number,
  Containers: number
}

function RollCounterByShipmentsAndContainers({ data }: Props) {
  function getData() {
    if (data) {
      const rollCounterData: IrollCounterData[] = data.reduce((res: IrollCounterData[], item: IShipmentsPerDay) => {
        const { departureDate, shipmentCount, containerCount } = item;
        let date = moment(departureDate).format("MM/YYYY");
        date = date[0] === "0" ? date.slice(1) : date;
        const Shipments = parseInt(shipmentCount);
        const Containers = parseInt(containerCount);
        const existingItem = res.find(v => v.date === date);

        if (existingItem) {
          existingItem.Shipments += Shipments;
          existingItem.Containers += Containers;
        } else {
          const newItem: IrollCounterData = {
            date,
            Shipments,
            Containers
          }
          res.push(newItem);
        }

        return res;
      }, []);

      return rollCounterData;
    }
  }

  return (
    <div className="roll-counter-by-shipments-and-containers">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span>Dates are in Actual Departure Date</span>
                <span><b>Container</b> count and <b>Ref</b> counts</span>
              </>
            }
            children="Roll Counter By Shipments & Containers"
          />
        }
        data={getData()}
        keys={["Shipments", "Containers"]}
        indexBy="date"
        marginBottom={50}
        axisLeftName="Totals"
        axisBottomName=""
        axisBottomRotation={-45}
        groupMode="grouped"
        colors={{ scheme: "nivo" }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 80,
            itemHeight: 12,
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 50,
          },
        ]}
        formatValue={(v) => NumberUtils.toShortened(v, 2)}
        tooltip={({ id, value, color }) => (
          <div className="tooltip-panel" style={{ color }}>
            <div>{id}: <strong>{NumberUtils.numberWithCommas(value)}</strong></div>
          </div>
        )}
      />
    </div>
  );
}

export default RollCounterByShipmentsAndContainers;
